import { PersonaInitialsColor } from '../components/Persona.Props';

interface PersonaInitialsColorStyle {
    initialsIsLightBlue: string;
    initialsIsBlue: string;
    initialsIsTeal: string;
    initialsIsLightGreen: string;
    initialsIsGreen: string;
    initialsIsDarkGreen: string;
    initialsIsLightPink: string;
    initialsIsPink: string;
    initialsIsMagenta: string;
    initialsIsPurple: string;
    initialsIsBlack: string;
    initialsIsOrange: string;
    initialsIsRed: string;
    initialsIsDarkRed: string;
}

const getPersonaInitialsColorClass = (styles: PersonaInitialsColorStyle) => ({
    [PersonaInitialsColor.lightBlue]:
        'ms-Persona-initials--lightBlue ' + styles.initialsIsLightBlue,
    [PersonaInitialsColor.blue]: 'ms-Persona-initials--blue ' + styles.initialsIsBlue,
    [PersonaInitialsColor.darkBlue]: 'ms-Persona-initials--darkBlue ' + styles.initialsIsBlue,
    [PersonaInitialsColor.teal]: 'ms-Persona-initials--teal ' + styles.initialsIsTeal,
    [PersonaInitialsColor.lightGreen]:
        'ms-Persona-initials--lightGreen ' + styles.initialsIsLightGreen,
    [PersonaInitialsColor.green]: 'ms-Persona-initials--green ' + styles.initialsIsGreen,
    [PersonaInitialsColor.darkGreen]:
        'ms-Persona-initials--darkGreen ' + styles.initialsIsDarkGreen,
    [PersonaInitialsColor.lightPink]:
        'ms-Persona-initials--lightPink ' + styles.initialsIsLightPink,
    [PersonaInitialsColor.pink]: 'ms-Persona-initials--pink ' + styles.initialsIsPink,
    [PersonaInitialsColor.magenta]: 'ms-Persona-initials--magenta ' + styles.initialsIsMagenta,
    [PersonaInitialsColor.purple]: 'ms-Persona-initials--purple ' + styles.initialsIsPurple,
    [PersonaInitialsColor.black]: 'ms-Persona-initials--black ' + styles.initialsIsBlack,
    [PersonaInitialsColor.orange]: 'ms-Persona-initials--orange ' + styles.initialsIsOrange,
    [PersonaInitialsColor.red]: 'ms-Persona-initials--red ' + styles.initialsIsRed,
    [PersonaInitialsColor.darkRed]: 'ms-Persona-initials--darkRed ' + styles.initialsIsDarkRed,
});

export default getPersonaInitialsColorClass;
